/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('GroupPersonManagerForDialogCtrl', ["$rootScope",'$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($rootScope,$scope, $http, NetworkService, MainService, IntentService) {

        $scope.mitarbeiter = []
        $scope.mitarbeiterInGroup = []
        $rootScope.$on("getGroupMembersForDialog", function () {

            var data = {group: $scope.mitarbeiterInGroup}
            $rootScope.$emit("getGroupMembersReturnForDialog", data)

        })





        $scope.updateInGroup = function(event, data)
        {
            $scope.mitarbeiterInGroup = data
        }

        $rootScope.$on("setGroupMembers", $scope.updateInGroup)

        NetworkService.getMitarbeiterNames(function (data)
        {
            $scope.mitarbeiter = data
        })

        $scope.changeStateInGroup = function (Email)
        {

            $scope.mitarbeiterInGroup.forEach(function (el) {
                if (el.Email == Email)
                {
                    el.active = true
                }
            })
        }

        $scope.moveToPersons = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.mitarbeiterInGroup.forEach(function (el) {
                if (el.active)
                {

                } else
                {
                    var newEl = {}
                    newEl.Vorname = el.Vorname
                    newEl.Nachname = el.Nachname
                    newEl.Email = el.Email
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.mitarbeiterInGroup = newMitarbeiterInGroup;
        }

        $scope.changeState = function (Email)
        {
            $scope.mitarbeiter.forEach(function (el) {
                if (el.Email == Email)
                {
                    el.active = true
                }
            })
        }

        $scope.moveToGroup = function ()
        {
            $scope.mitarbeiter.forEach(function (el) {
                if (el.active)
                {
                    el.active = false;
                    var newEl = {}
                    newEl.Vorname = el.Vorname
                    newEl.Nachname = el.Nachname
                    newEl.Email = el.Email
                    $scope.mitarbeiterInGroup.push(newEl)
                }
            })
        }

    }])
